import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export function ReactQueryClientProvider({
  children,
  queryClient,
}: React.PropsWithChildren<{ queryClient: QueryClient }>) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
